export default __webpack_public_path__ + "fe308568a41e912c9eaffae34f8966fb.png";